import React from 'react';
import styled from 'styled-components';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';

export default function PrintViewDropdownBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	let selectedOption =
		body.optionsAndResponses &&
		body.optionsAndResponses.find((opt) => {
			return 1 === opt.bodySelectedOptionId;
		});

	return (
		<StyledPrintViewDropdownBody className={`StyledPrintViewDropdownBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewDropdownBodyData" id={body.id}>
				<section className="printDropdown">
					{selectedOption ? selectedOption.bodyOptionText : labels.notSelected}
				</section>
			</section>
		</StyledPrintViewDropdownBody>
	);
}

const StyledPrintViewDropdownBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.printDropdown {
		border: var(--px-1) solid var(--neutrals-300) !important;
		max-width: var(--px-700);
		padding: var(--px-1) var(--px-6);
		margin-top: var(--px-5);
	}
`;
